export default __webpack_public_path__ + "static/media/pay-to-restaurant.3f782366.svg";